import { fromJS, List, Map } from 'immutable';
import { combineActions, createAction, handleActions } from 'redux-actions';
import api from '../../utils/api';

export const initialState = fromJS({
  itemsByProfile: Map(),
  isLoading: false,
});

// const
export const GET_SHOPIFY_ITEMS = 'shopifyItems/GET_SHOPIFY_ITEMS';
export const CREATE_SHOPIFY_ITEM = 'shopifyItems/CREATE_SHOPIFY_ITEM';
export const EXPORT_TO_SHOPIFY = 'shopifyItems/EXPORT_TO_SHOPIFY';
export const FETCH_SHOPIFY_EXPORT_STATES =
  'shopifyItems/FETCH_SHOPIFY_EXPORT_STATES';

// action creators
export const getShopifyItems = createAction(GET_SHOPIFY_ITEMS, (profileId) =>
  api.shopify
    .getItems(profileId)
    .then((response) => response.set('_profileId', profileId)),
);
export const createShopifyItem = createAction(
  CREATE_SHOPIFY_ITEM,
  (profileId, data) =>
    api.shopify
      .createItem(profileId, data)
      .then((response) => response.set('_profileId', profileId)),
);
export const exportToShopify = createAction(
  EXPORT_TO_SHOPIFY,
  (itemId, profileId) =>
    api.shopify.exportInventoryItemToShopify(itemId, profileId),
);
export const fetchShopifyExportStates = createAction(
  FETCH_SHOPIFY_EXPORT_STATES,
  () =>
    api.shopify.getProfiles().then((profilesResponse) => {
      const profiles = profilesResponse.get('data', List());
      if (!profiles.size) return fromJS({ profileItems: List() });

      return Promise.all(
        profiles
          .map((p) =>
            api.shopify
              .getItems(p.get('id'))
              .then((response) => response.set('_profileId', p.get('id'))),
          )
          .toArray(),
      ).then((responses) => fromJS({ profileItems: List(responses) }));
    }),
);

// reducer
const shopifyItems = handleActions(
  {
    [combineActions(
      `${GET_SHOPIFY_ITEMS}_REQUEST`,
      `${CREATE_SHOPIFY_ITEM}_REQUEST`,
      `${EXPORT_TO_SHOPIFY}_REQUEST`,
      `${FETCH_SHOPIFY_EXPORT_STATES}_REQUEST`,
    )]: (state) => state.set('isLoading', true),

    [combineActions(
      `${GET_SHOPIFY_ITEMS}_ERROR`,
      `${CREATE_SHOPIFY_ITEM}_ERROR`,
      `${EXPORT_TO_SHOPIFY}_ERROR`,
      `${FETCH_SHOPIFY_EXPORT_STATES}_ERROR`,
    )]: (state) => state.set('isLoading', false),

    [`${GET_SHOPIFY_ITEMS}_SUCCESS`]: (state, { payload }) => {
      const profileId = payload.get('_profileId');
      return state
        .setIn(['itemsByProfile', profileId], payload.get('data', List()))
        .set('isLoading', false);
    },

    [`${CREATE_SHOPIFY_ITEM}_SUCCESS`]: (state, { payload }) => {
      const profileId = payload.get('_profileId');
      return state
        .updateIn(['itemsByProfile', profileId], (items = List()) =>
          items.push(payload.get('data')),
        )
        .set('isLoading', false);
    },

    [`${EXPORT_TO_SHOPIFY}_SUCCESS`]: (state, { payload }) => {
      const data = payload.get('data', Map());
      const profileId = data.get('user_shopify_profile_id');
      return state
        .updateIn(['itemsByProfile', profileId], (items = List()) =>
          items.push(data),
        )
        .set('isLoading', false);
    },

    [`${FETCH_SHOPIFY_EXPORT_STATES}_SUCCESS`]: (state, { payload }) => {
      const profileItems = payload.get('profileItems', List());
      let newState = state.set('isLoading', false);
      profileItems.forEach((response) => {
        const profileId = response.get('_profileId');
        newState = newState.setIn(
          ['itemsByProfile', profileId],
          response.get('data', List()),
        );
      });
      return newState;
    },
  },
  initialState,
);

export default shopifyItems;
